import React, { useEffect } from "react";
import { Button, Column, Icon, Row, Text } from "@amzn/meridian";
import { useNavigate, useParams } from "react-router-dom";
import QuestionsList from "./questionsList";
import { useAppDispatch, useAppSelector } from "src/store/store";
import chevronLeftLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-left-large";
import { COLORS } from "src/constants/colors";
import { createNewInspection, setActiveQuestion } from "src/store/dataSlice";

const QuestionsPage = () => {
  const { selectedInspectionTemplate } = useAppSelector((state) => state.data);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  return (
    <Column
      className="questions-page"
      height="100vh"
      alignmentVertical="justify"
      backgroundColor={COLORS.DARKER_WHITE}
    >
      <Column>
        <Column
          width="100%"
          backgroundColor={COLORS.WHITE}
          spacingInset="600 500 400"
        >
          <Row>
            <div
              style={{ cursor: "pointer", marginLeft: "50px" }}
              onClick={() => navigate("/templates")}
            >
              <Icon tokens={chevronLeftLargeTokens} color="primary" />
            </div>
            <Text type="h200">Inspection</Text>
          </Row>
          <Column>
            <Row>
              {selectedInspectionTemplate?.templateName && (
                <Text type="b500">
                  {selectedInspectionTemplate?.templateName}
                </Text>
              )}
            </Row>
          </Column>
        </Column>
        <Column spacingInset="none 500">
          <QuestionsList />
        </Column>
      </Column>
      <Column spacingInset="500">
        <Button
          size="large"
          onClick={() => {
            if (selectedInspectionTemplate) {
              dispatch(
                createNewInspection({
                  templateId: selectedInspectionTemplate.templateId,
                  templateName: selectedInspectionTemplate.templateName,
                  siteCode: selectedInspectionTemplate.siteCode || "ABE2",
                })
              );
              dispatch(
                setActiveQuestion(selectedInspectionTemplate?.questions[0])
              );
              navigate(
                `/templates/${selectedInspectionTemplate?.templateId}/inspection`
              );
            }
          }}
        >
          Start Inspection
        </Button>
      </Column>
    </Column>
  );
};

export default QuestionsPage;
